import { DataBuilderHttpError } from './errors';

export async function fetchJson<T>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const headers = new Headers(init?.headers);
  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(input, {
    credentials: 'include',
    ...init,
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    const responseRequestId =
      response.headers.get('x-request-id') ??
      response.headers.get('request-id');
    throw new DataBuilderHttpError(
      message || 'Unknown error',
      response.status,
      response.statusText,
      responseRequestId ?? ''
    );
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return await response.json();
}
